const VideoReviewOptions = ["upheld", "rejected"];

export const ModifyVideoReviewOutcome = {
  name: "modify-video-review-outcome",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.penalty.success",
  showOn: [{ state: "editState", value: "video-review-outcome", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "outcome-change-to-upheld",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [
        {
          state: "event.subType",
          value: "rejected",
          operator: "is",
          event: "main",
        },
      ],
      options: {
        layout: "description-text",
        text: "videoReview.change.to.upheld",
      },
      actionGroups: [],
    },
    {
      name: "outcome-change-to-rejected",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [
        {
          state: "event.subType",
          value: "upheld",
          operator: "is",
          event: "main",
        },
      ],
      options: {
        layout: "description-text",
        text: "videoReview.change.to.rejected",
      },
      actionGroups: [],
    },
    {
      name: "confirm-panel",
      component: "SubPanel",
      layout: "sub-panel",
      mode: "visible",
      text: null,
      showOn: [true],
      children: [
        {
          name: "ok-button",
          component: "TypeButton",
          layout: "match-button action",
          mode: "enable",
          text: "ok",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                {
                  action: "switchValues",
                  value: {
                    eventType: "videoReview",
                    property: "subType",
                    values: ["upheld", "rejected"],
                  },
                  type: "main",
                },
                {
                  action: "nextState",
                  value: null,
                  type: "editState",
                },
              ],
              conditions: [],
            },
          ],
        },
      ],
    },
  ],
};
